<template>
	<div class="login">
		<div class="alert_logIn">
			<p class="login_text">欢迎登录电巢</p>
			<img class="login_img" src="../../assets/image/course/login.png" alt="">
			<div>
				<div>
					<input type="number" placeholder="请输入手机号" class="phone" v-model="phone" @input="phoneInput">
				</div>
				<div class="get_verification_code">
					<input type="number" placeholder="请输入验证码" class="verification_code" v-model="smsCode">
					<div class="getCode" :class="{checkValid: codeEnabled}" @click="getSmsCode">{{buttonMsg}}</div>
				</div>

				<div class="bottomArea">
					<div class="login_btn" :class="{loginCheckValid: loginEnabled}" @click="login">
						<p>登录</p>
					</div>
					<div class="bottom">
						<p class="agreement">
							<input type="checkbox" @click="getHint($event)">
							<span>未注册的用户我们将会自动为您创建账户</span>
						</p>
						<p>登录即代表您同意<span class="link" @click="linkOutTo(pagebase + '/h5/agreement/elecomPrivacyPolicy.html')">《电巢隐私政策》</span>和<span class="link" @click="linkOutTo(pagebase + '/h5/agreement/elecomServeAgreement.html')">《电巢服务协议》</span></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import utils from '@/utils/utils'
  import {pagebase} from '@/utils/http'

	export default {
		data() {
			return {
				phone: '',
				smsCode: '',
				checkboxValue: false,
				codeEnabled: false,
				limitTime: 60,
				buttonMsg: '发送验证码',
        
        pagebase: pagebase,
			}
		},
		inject: ['commonData'],
		computed: {
			loginEnabled() {
				return this.codeEnabled && this.smsCode && this.checkboxValue
			}
		},
		methods: {
			getSmsCode() {
				if (this.codeEnabled) {
					this.$http.get('/Registered/getPhoneSmsCode', {
						params: utils.cso({
							phone: this.phone,
							phone_head: 86,
							type: 10,
							client: 'H5'
						})
					}).then((res) => {
						if (res.code >= 0) {
							this.buttonMsg = this.limitTime + 's'
							this.timer = window.setInterval(() => {
								this.limitTime--
								this.buttonMsg = this.limitTime + 's'
								if (this.limitTime < 0) {
									window.clearInterval(this.timer)
									this.buttonMsg = '发送验证码'
									this.limitTime = 60
								}
							}, 1000)
						} else {
							utils.showMessage(res.msg);
						}
					})
				}
			},
			login() {
				if (this.loginEnabled) {
					let body = {
						phone_head: 86,
						phone: this.phone,
						sms_code: this.smsCode,
						mp_openid: this.commonData.openid,
						buy_together_id: this.commonData.togetherId || '',
						timestamp: new Date().getTime() / 1000,
						nonce: `${ Math.random().toString().slice(2) }${ this.smsCode }`
					}
					Object.assign(body, {
						sign: utils.loginSign(body)
					})
					this.$http.get('/Login/wxLogin', {
						params: body
					}).then(res => {
						if (res.code >= 0) {
							this.$emit('login', res.data)
						} else if (res.code == -888) {
							this.$emit('updateCommonData', {
								phone: this.phone,
								smsCode: this.smsCode
							})
							this.$emit('changeMode', 'account')
						} else {
							utils.showMessage(res.msg)
						}
					})
				} else if(!this.checkboxValue){
					utils.showMessage('请勾选服务协议后再登录');
				}
			},
			getHint(e) {
				let type = e.target.checked;
				if (type) {
					this.checkboxValue = true;
				} else {
					this.checkboxValue = false;
				}
			},
			phoneInput(e) {
				let value = e.target.value
				this.codeEnabled = utils.checkPhone(value)
			},
			linkOutTo(url) {
				this.$emit('linkOutTo', url)
			}
		}
	}
</script>

<style lang="css" scoped>
	input {
		border: none;
		outline: none;
	}

	.green {
		color: #00FF33;
	}

	.alert_logIn {
		position: fixed;
		z-index: 10;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		background-color: #FFFFFF;
		padding: 0 3.6rem;
	}

	.login_text {
		font-size: 2.6rem;
		font-weight: bolder;
		margin-top: 3.65rem;
	}

	.login_img {
		height: 5rem;
		margin-top: 1.6rem;
	}

	.phone {
		margin-top: 3rem;
		box-sizing: border-box;
		width: 100%;
		background-color: #f2f4f5;
		height: 4.5rem;
		font-size: 1.6rem;
		border-radius: 2.25rem;
		padding: 0 1.6rem;
	}

	.get_verification_code {
		display: flex;
		justify-content: space-between;
		margin-top: 3rem;
	}

	.verification_code {
		box-sizing: border-box;
		width: 17rem;
		height: 4.5rem;
		background-color: #f2f4f5;
		border-radius: 2.25rem;
		font-size: 1.6rem;
		padding: 0 1.6rem;
	}

	.getCode {
		text-align: center;
		width: 12.1rem;
		height: 4.3rem;
		line-height: 4.5rem;
		font-size: 1.6rem;
		border: .1rem solid #FCD0CB;
		border-radius: 4.5rem;
		color: #FCD0CB;
	}

	.checkValid {
		text-align: center;
		width: 12.1rem;
		height: 4.3rem;
		line-height: 4.5rem;
		font-size: 1.6rem;
		border: .1rem solid #E50101;
		border-radius: 4.5rem;
		color: #E50101;
	}

	.bottomArea {
		margin-top: 3rem;
	}


	.login_btn {
		display: flex;
		justify-content: center;
	}

	.login_btn p {
		width: 30rem;
		height: 4.5rem;
		line-height: 4.5rem;
		text-align: center;
		color: #FFFFFF;
		font-size: 1.8rem;
		font-weight: bolder;
		border-radius: 4.5rem;
		background-color: #FCD0CB;
	}

	.loginCheckValid p {
		width: 30rem;
		height: 4.5rem;
		line-height: 4.5rem;
		text-align: center;
		color: #FFFFFF;
		font-size: 1.8rem;
		font-weight: bolder;
		border-radius: 4.5rem;
		background-color: #E50101;
	}

	.bottom {
		margin-top: 15px;
		text-align: center;
		font-size: 1.2rem;
		color: #808598;
	}

	.link {
		color: #007eff;
	}

	.agreement {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.agreement input {
		margin-right: .5rem;
	}

	.agreement span {
		margin-top: -.1rem;
	}
</style>
